import { render, staticRenderFns } from "./EditUniverseButton.vue?vue&type=template&id=8dba9806&scoped=true&"
import script from "./EditUniverseButton.vue?vue&type=script&lang=js&"
export * from "./EditUniverseButton.vue?vue&type=script&lang=js&"
import style0 from "./EditUniverseButton.vue?vue&type=style&index=0&id=8dba9806&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dba9806",
  null
  
)

export default component.exports